import { useEffect, useState } from "react";
import { Navigate, useLocation, useParams, useSearchParams } from "react-router-dom";

import ContractDetailsSkeleton from "@/components/pages/client/contractDetails/contract-details-skeleton";
import Footer from "@/components/layout/Footer";
import { HeaderUser } from "@/components/layout/header/HeaderUser";
import MobileTabs from "@/components/layout/mobile-tabs";
import Sidebar from "@/components/layout/Sidebar";
import { useAuth } from "@/contexts/auth-context";

function ContractPageSkeleton() {
  return (
    <div className="bg-n-bg-3 flex flex-col min-h-screen">
      <HeaderUser />
      <div className="flex flex-1">
        <Sidebar />
        <div className="pt-[72px] px-[3%] mx-auto flex-1 pb-16 lg:pb-0">
          <div className="py-6 md:py-10 max-w-7xl w-full mx-auto">
            <h1 className="mb-10 text-2xl sm:text-[32px] font-semibold text-n-text-green">
              Detalhes do Contrato
            </h1>
            <ContractDetailsSkeleton />
          </div>
        </div>
      </div>
      <MobileTabs />
      <Footer />
    </div>
  );
}

export function TokenContractRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, signInWithToken } = useAuth();
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const token = searchParams.get("token");

  const [status, setStatus] = useState<"checking" | "done" | "failed">(
    isAuthenticated ? "done" : "checking",
  );

  useEffect(() => {
    if (token && id) {
      if (isAuthenticated) {
        signInWithToken(token, id).catch(() => {});
        return;
      }

      signInWithToken(token, id)
        .then(() => setStatus("done"))
        .catch(() => setStatus("failed"));
      return;
    }

    if (!isAuthenticated) {
      setStatus("failed");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === "checking") return <ContractPageSkeleton />;
  if (status === "failed") {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
